/* @ngInject */
function DocumentsController ($state) {
  if ($state.current.name === 'documents') {
    $state.go('documents.list')
  }
}

export { DocumentsController }
